import React, { useState, useEffect } from 'react';
import { EditPage, EditPagePanel, EditPageTextField, EditPageTextArea, EditPageCheckbox } from '../../common/EditPage';
import Panel from '../../common/layout/Panel';
import { toast, ToastContainer } from 'react-toastify';
import { getList, create } from '../../common/v4/BackendProvider';
import AsyncSelectContainer from '../../common/AsyncSelectContainer';
import Select from 'react-select';

const SendSms = () => {
    const [clients, setClients] = useState([]);
    const [sourceNumbers, setSourceNumbers] = useState([]);
    const [form, setForm] = useState({
        client_id: '',
        number_id: '',
        destination: '',
        message: '',
        dlr: false
    });

    // Load initial clients when component mounts
    useEffect(() => {
        loadClients('').then(initialClients => {
            if (initialClients.length > 0) {
                setClients(initialClients);
            }
        });
    }, []);

    // Load source numbers when client changes
    useEffect(() => {
        if (form.client_id) {
            loadSourceNumbers('').then(initialNumbers => {
                if (initialNumbers.length > 0) {
                    setSourceNumbers(initialNumbers);
                }
            });
        } else {
            setSourceNumbers([]);
        }
    }, [form.client_id]);

    // Function to load clients dynamically based on search term
    const loadClients = async (inputValue) => {
        try {
            // If no input value, load initial results (first 50 clients)
            const params = inputValue ? [
                { key: 'search', value: inputValue },
                { key: 'limit', value: 50 }
            ] : [
                { key: 'limit', value: 50 }
            ];
            
            const response = await getList('/admin/clients/clients', params);
            
            if (response.data?.result === 'OK') {
                // Convert to array format with value and label
                const clients = response.data.data.map(client => ({
                    value: client.ATRCLIENTID,
                    label: `${client.ATRACCTNAME} (${client.ATRCLIENTIDNUMBER})`
                }));
                return clients;
            }
            return [];
        } catch (error) {
            console.error('Error loading clients:', error);
            toast.error('Failed to load clients');
            return [];
        }
    };

    // Function to load source numbers dynamically based on client ID
    const loadSourceNumbers = async (inputValue) => {
        try {
            // Safety check: ensure client is selected
            if (!form.client_id) {
                return [];
            }
            
            // If no input value, load initial results (first 50 numbers)
            if (!inputValue) {
                const response = await getList(`/admin/clients/clients/${form.client_id}/numbers`, [
                    { key: 'limit', value: 50 }
                ]);
                
                if (response.data?.result === 'OK') {
                    const numbers = response.data.data.map(number => ({
                        value: number.id,
                        label: number.number
                    }));
                    return numbers;
                }
                return [];
            }
            
            // If search term provided, search for numbers
            const params = [
                { key: 'search', value: inputValue },
                { key: 'limit', value: 50 }
            ];
            
            const response = await getList(`/admin/clients/clients/${form.client_id}/numbers`, params);
            
            if (response.data?.result === 'OK') {
                // Convert to array format with value and label
                return response.data.data.map(number => ({
                    value: number.id,
                    label: number.number
                }));
            }
            return [];
        } catch (error) {
            console.error('Error loading source numbers:', error);
            toast.error('Failed to load source numbers');
            return [];
        }
    };

    const onChange = (id, value) => {
        setForm(prev => ({ ...prev, [id]: value }));
    };

    const handleSend = () => {
        create('/admin/sms/send', { data: form }).then(res => {
            if (res.data?.result === 'OK') {
                toast.success('SMS sent successfully');
            } else {
                toast.error(res.data?.message || 'Failed to send SMS');
            }
        }).catch(err => {
            console.log(err);
            toast.error(err.response.data.message || 'Failed to send SMS');
        });
    };

    const handleCancel = () => {
        setForm({ client_id: '', number_id: '', destination: '', message: '', dlr: false });
    };

    return (
        <Panel title="Send SMS">
            <>
                <ToastContainer position="top-right" autoClose={5000} />
                <EditPage handleSave={handleSend} handleCancel={handleCancel} noDefaultButtons>
                    <EditPagePanel>
                        <AsyncSelectContainer
                            label="Client"
                            id="client_id"
                            onChange={onChange}
                            value={form.client_id}
                            placeholder="Type to search clients..."
                            loadOptions={loadClients}
                            isClearable={true}
                            defaultOptions={true}
                            key="client-select"
                        />
                        <AsyncSelectContainer
                            label="Source Number"
                            id="number_id"
                            onChange={onChange}
                            value={form.number_id}
                            placeholder="Select number..."
                            disabled={!form.client_id}
                            loadOptions={loadSourceNumbers}
                            defaultOptions={sourceNumbers}
                            key={`number-select-${form.client_id}`}
                        />
                        <EditPageTextField
                            label="Destination Number"
                            id="destination"
                            value={form.destination}
                            onChange={onChange}
                            placeholder="Enter destination number..."
                        />
                        <EditPageTextArea
                            label="Message Body"
                            id="message"
                            value={form.message}
                            onChange={onChange}
                            placeholder="Enter message..."
                            rows={4}
                        />
                        <EditPageCheckbox
                            label="Request DLR (Delivery Report)"
                            id="dlr"
                            value={form.dlr}
                            onChange={onChange}
                        />
                         <div className="panel-footer" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
                            <button type="button" className="btn btn-default" onClick={handleCancel}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={handleSend}>Send</button>
                        </div>
                    </EditPagePanel>
                   
                </EditPage>
            </>
        </Panel>
    );
};

export default SendSms;